export const ctmEnableErrorMsg =
  'Error occurred while enabling Call Taker Mode. Contact support@rapidsos.com if this error persists.';
export const ctmDisableErrorMsg =
  'Error occurred while disabling Call Taker Mode. Contact support@rapidsos.com if this error persists.';
